import { ModalColor } from '~shared/types/modal';

const colorScheme = {
  [ModalColor.PRIMARY]: {
    icon: 'blue-500',
    button: 'primary-dark',
  },
  [ModalColor.DANGER]: {
    icon: 'red-500',
    button: 'primary-dark',
  },
  [ModalColor.WARNING]: {
    icon: 'yellow-400',
    button: 'primary-dark',
  },
};

export default colorScheme;
